module.exports = __webpack_public_path__ + "static/img/title.34fe13bf.gif";